import { gql } from "apollo-boost";

export const DELETE_PRODUCT = gql`
  mutation DeleteProduct($where: ProductWhereInputOne!) {
    deleteProduct(where: $where) {
      id
    }
  }
`;

export const UPDATE_PRODUCT = gql`
  mutation UpdateProduct($where: ProductWhereInputOne!, $data: ProductInput!) {
    updateProduct(where: $where, data: $data) {
      id
    }
  }
`;

export const CREATE_PRODUCT = gql`
  mutation CreateProduct($data: ProductInput!) {
    createProduct(data: $data) {
      id
    }
  }
`;
export const CREATE_PRODUCT_V2 = gql`
  mutation CreateProductV2($data: ProductInput!) {
    createProductV2(data: $data) {
      message
      success
      data{
        id
      }
    }
  }
`;
export const CREATE_MANY_PRODUCTS = gql`
  mutation CreateManyProduct(
    $where: StockShopWhereInput!
    $data: [ProductInput!]
  ) {
    createManyProduct(where: $where, data: $data) {
      count
    }
  }
`;
export const CREATE_MANAGEMENT_PRODUCTS = gql`
  mutation CreateManagementProduct($where: StockShopWhereInput!, $data: [ProductInput!]) {
    createManagementProduct(where: $where, data: $data) {
      status
      msg
      total
      err
      dataMany {
        id
      }
    }
  }
`;

export const UPDATE_MANY_PRODUCT = gql`
  mutation UpdateManyProduct(
    $data: ProductInput!
    $where: ProductWhereInputMany!
  ) {
    updateManyProduct(data: $data, where: $where) {
      count
    }
  }
`;

export const UPDATE_START_PRODUCT = gql`
  mutation UpdateStarProduct($where: ProductWhereInputOne!) {
    updateStarProduct(where: $where) {
      id
      star
    }
  }
`;

export const CANCEL_STAR_PRODUCT = gql`
  mutation CancelStarProduct($where: ProductWhereInputOne!) {
    cancelStarProduct(where: $where) {
      id
      star
    }
  }
`;

export const DELETE_PRODUCT_FORM_DB = gql`
mutation DeletedProductFromDB($where: ProductWhereInputMany!) {
  deletedProductFromDB(where: $where) {
    id
  }
}
`;

export const RECOVER_PRODUCT_OLD = gql`
  mutation ReCoverProduct($where: ProductWhereInputMany!) {
    reCoverProduct(where: $where) {
      id
    }
  }
`;
